<template>
  <v-row align="baseline" dense>
    <slot name="label">
      <v-col cols="12" sm="6" :md="labelSize" v-if="label && !hideLabel">
        <v-card class="d-flex" flat>
          <v-tooltip v-if="nullable" top>
            <template #activator="{ on }">
              <v-card v-on="on" height="32" flat>
                <v-switch
                  v-model="nullValue"
                  dense
                  class="mt-0"
                  @change="$emit('change')"
                ></v-switch>
              </v-card>
            </template>
            <span>{{ nullValue ? "Disable" : "Enable" }}</span>
          </v-tooltip>
          <v-card flat>
            <span :class="`subtitle-2 ${disabledLabel} ${focused ? 'primary--text' : ''}`">
              {{ label }}
            </span>
            <div v-if="hint">
              <span class="text-caption">{{ hint }}</span>
            </div>
          </v-card>
        </v-card>
      </v-col>
    </slot>
    <v-col v-if="extraButton" class="shrink">
      <slot name="extraButton"></slot>
    </v-col>
    <v-col v-if="!nullable || (nullable && nullValue)" class="grow" :class="[inputSpacing]">
      <v-text-field
        v-model="computedValue"
        v-bind="$props"
        v-on="$listeners"
        label=""
        hint=""
        dense
        :class="[inputSpacing]"
        @focus="focus"
        @blur="blur"
        @change="$emit('change')"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "InputTextField",
  components: {},
  mixins: [],
  props: {
    value: {
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    hideLabel: {
      type: Boolean,
      required: false,
      defalut: false,
    },
    hint: {
      type: String,
      required: false,
      default: null,
    },
    suffix: { type: String, required: false, default: "" },
    type: {
      type: String,
      required: false,
      default: "text",
    },
    default: { type: [String, Number], required: false },
    min: {
      type: [Number, null],
      required: false,
      default: null,
    },
    max: {
      type: [Number, null],
      required: false,
      default: null,
    },
    labelSize: {
      type: Number,
      required: false,
      default: 5,
    },
    nullable: {
      type: Boolean,
      required: false,
      default: false,
    },
    extraButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    rules: {
      type: Array,
      required: false,
      default: () => [],
    },
    errorMessages: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      nullValue: !(this.value === null),
      focused: false,
    };
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        if (this.type === "number" && val !== null) {
          this.$emit("input", Number(val));
          return;
        }
        this.$emit("input", val);
        this.$emit("change");
      },
    },
    disabledLabel() {
      return this.nullable && this.nullValue ? "text--disabled" : "";
    },
    inputSpacing() {
      if (this.labelSize === 12) {
        return "mt-0 pt-0";
      }
      return "";
    },
  },
  watch: {
    nullValue(val) {
      if (!val) {
        this.$emit("input", null);
      } else if (this.type === "number") {
        this.$emit("input", 0);
      } else {
        this.$emit("input", "");
      }
      this.$emit("change");
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    focus() {
      this.focused = true;
    },
    blur() {
      this.focused = false;
    },
  },
};
</script>

<style></style>
